import React from "react";
import { SearchBar } from "./SearchBar";
import { MapFilter } from "./MapFilter";
import {  Stack, Box } from "@mui/material";
import { MapFilterProps } from './MapFilter'

export const MapBars: React.FC<MapFilterProps> = (props) => {
  return (<>
  <Box
    sx={{
      position: 'absolute',
      top: '72px',
      right: '10px',
      left: {
        xs: '10px',
        md: '376px',   // 20px (left col offset) + 340px (left col width) + 16px gap
      },
      zIndex: 1,
      pointerEvents: 'none'
    }}>
    
      <Stack sx={{width: '100%' }} gap={1}  >      
        <SearchBar  {...props}/>  
        <Box  sx={{  
          display: {   
            xs: 'none', // theme.breakpoints.up('xs')
            sm: 'none', // theme.breakpoints.up('sm')
            md: 'none', // theme.breakpoints.up('md')
            lg: 'none',
            xl: 'block'
          }}}
        >
              
        </Box>    
      </Stack>
    
    </Box>
  </>)

}